import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

import { apiEndpoint } from "../config";

export const createFileUploadLink = () => {
  return createUploadLink({
    uri: apiEndpoint,
    headers: { "GraphQL-preflight": "true" },
  });
};
